import { render } from "./EcoFaultNotTurnOn.vue?vue&type=template&id=546fd6f2"
import script from "./EcoFaultNotTurnOn.vue?vue&type=script&lang=js"
export * from "./EcoFaultNotTurnOn.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__